import React from 'react';


function VideoLineLoader(props) {
  const { isLoading } = props;

  if (!isLoading) {
    return null;
  }

  return (
    <div className="loader-line" />
  );
}

export default VideoLineLoader;
